import React, { Fragment, useState, useEffect, useContext } from "react";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate, useLocation } from "react-router";
import { updateGroups } from "../../api/group";
import Floading from "../../components/Floading/Floading";
import Swal from "sweetalert2";
import { Disclosure } from "@headlessui/react";
import FInput from "../../components/FInput/FInput";
import PhoneInput from "react-phone-input-2";
import { useFormik } from "formik";
import { getIdenticator } from "../../api/directory";
import FInputt from "../../components/FInputt/FInputt";
import { useFormat } from "../../hooks/useFormat";
import { useGroup } from "../../hooks/useGroups";
import { AuthContext } from "../../context/AuthContext";
import FModal from "../../components/FModal/FModal";
import AlertModal from "../../components/AlertModal/AlertModal";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import FContainer from "../../components/FContainer/FContainer";
import { PersonAddOutline } from "react-ionicons";
import Compress from "react-image-file-resizer";
import { useContacts } from "../../hooks/useContacts";

const ManageGroupScreen = ({ param }) => {
  const { getBase64 } = useFormat();
  const [srcFileZone, setSrcFileZone] = useState();

  const [loading, setloading] = useState(false);
  const [modalDeleteVisible, setModalDeleteVisible] = useState(false);
  const route = useNavigate();
  const parameters = useLocation();
  const [arrayMembers, setArrayMembers] = useState([]);
  const [edit, setEdit] = useState(false);
  const [add, setAdd] = useState(false);
  const [memberId, setMemberId] = useState("");
  const { aleatory3colors } = useContacts();

  const { checkToken } = useContext(AuthContext);

  const { state } = useLocation();

  useEffect(() => {
    console.log(state);
  }, []);

  useEffect(() => {
    checkToken()
    try {
      getMembers(state.group.id);
    } catch (error) {
      setMembers([]);
    }
  }, [arrayMembers]);

  useEffect(() => {
    getMembers(state.group.id);
  }, []);

  const { getMembers, members, deleteMember, deleteGroup, setMembers, updateGroup } =
    useGroup();

  const idMembers = members.map((member) => member.directoryId);
  const [aleatory3colorss, setaleatory3colorss] = useState('')

  useEffect(() => {
    _getMembersByGroupId(state.group.id);
    formikEdit.setFieldValue("name", state.group.name);
    setaleatory3colorss(aleatory3colors())

  }, []);

  async function _getMembersByGroupId(groupId) {
    checkToken()
    let _return = false;
    setloading(true);
    try {
      //const dataGetMembersByGroupId = await getMembersByGroupId(groupId);
      setloading(false);
      //const res = dataGetMembersByGroupId.data;
      // if (res.code == "PROCESS_OK") {
      //   //console.log("dataGetMembersByGroupId", res.data.members);
      //   setArrayMembers(res.data.members);
      // }
    } catch (error) {
      setloading(false);
      const res = error.response.data;
      if (res.code == "NOT_FOUND") {
      }
    }
    return _return;
  }

  const onDeleteClickBanks = (data) => {
    Swal.fire({
      showCloseButton: true,
      title: "Eliminar",
      text: "¿Está seguro que desea eliminar a esta persona del grupo?",
      imageUrl: require("../../components/assets/images/pregunta.png"),
      imageWidth: 150,
      imageHeight: 150,
      imageAlt: "Custom image",
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#dc3545",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        _deleteMemberByGroupIdByMemberId(data);
      }
    });
  };

  async function _deleteMemberByGroupIdByMemberId(data) {
    checkToken()
    let _return = false;
    setloading(true);
    try {
      await deleteMember(state.group.id, data.directoryId);
      setMembers(
        members.filter((item) => item.directoryId != data.directoryId)
      );
    } catch (error) {
      setloading(false);
      const res = error.response.data;
      if (res.code == "NOT_FOUND") {
        // Swal.fire({
        //   title: "Código incorrecto",
        //   text: "",
        //   imageUrl: require("../../components/assets/images/advertir.png"),
        //   imageWidth: 150,
        //   imageHeight: 150,
        //   confirmButtonColor: "#fd6e0d",
        // });
      }
    }
    return _return;
  }

  const formikEdit = useFormik({
    initialValues: {
      name: "",
      description: state?.group?.description,
    },
    onSubmit: async (values) => {
      let _data = {
        name: values.name,
        description: values.description,
        img: srcFileZone,
      };
      //console.log(_data);
      const res = await _updateGroups(values);
      if (res) {
        //setDescriptionGroupBanner(values.description);
        //setNameGroupBanner(values.name);
        //setImgGroupBanner(srcFileZone);
      }
    },
    validate: (values) => {
      const errors = {};
      if (!values.name) errors.name = "Campo Requerido";
      if (!values.description) errors.description = "Campo Requerido";
      return errors;
    },
  });

  async function _updateGroups(data) {
    checkToken()
    let _return = false;
    setloading(true);
    try {
      const dataUpdateGroups = await updateGroups(
        parameters.state.group.id,
        data
      );
      setloading(false);
      const res = dataUpdateGroups.data;
      if (res.code == "PROCESS_OK") {
        _return = true;
      }
    } catch (error) {
      setloading(false);
      const res = error.response.data;
      if (res.code == "NOT_FOUND") {
        // Swal.fire({
        //   title: "Código incorrecto",
        //   text: "",
        //   imageUrl: require("../../components/assets/images/advertir.png"),
        //   imageWidth: 150,
        //   imageHeight: 150,
        //   confirmButtonColor: "#fd6e0d",
        // });
      }
    }
    return _return;
  }

  useEffect(() => { }, [memberId]);

  const [image, setImage] = useState(
    state?.group?.picture
  );
  const [srcFileZoneSideBar, setSrcFileZoneSideBar] = useState();

  const nextScreenImg = async (groupId, data) => {
    if ((await updateGroup(groupId, data)) == true) {
      setImage(data.picture);
      setSrcFileZoneSideBar(data.picture);

      Swal.fire({
        showCloseButton: true,
        title: "Éxito",
        text: "Actualización correcta",
        icon: "success",
        imageWidth: 150,
        imageHeight: 150,
        imageAlt: "Custom image",
        confirmButtonColor: "#28a745",
        confirmButtonText: "Aceptar",
        reverseButtons: true,
      })
    } else {
      Swal.fire({
        showCloseButton: true,
        title: 'Advertencia',
        text: "Su solicitud no puede ser procesada",
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        iconColor: "#fd6e0d",
        confirmButtonText: 'Entendido'
      })
    }
  };


  const onFileResize = e => {
    const file = e.target.files[0];

    Compress.imageFileResizer(
      file, // the file from input
      480, // width
      480, // height
      "JPEG", // compress format WEBP, JPEG, PNG
      70, // quality
      0, // rotation
      (uri) => {
        // editGroupFormik.setFieldValue('picture', uri)
        nextScreenImg(state.group.id, { picture: uri });

      },
      "base64" // blob or base64 default base64
    );
  };

  return (
    <>
      <div className="border-0 grid place-items-center">
        <div className="border-0 grid grid-cols-12 xss:w-[450px] place-items-center">
          <div className="border-0 col-span-5 flex-1">
            <label className="cursor-pointer rounded-lg">
              <img
                src={!srcFileZoneSideBar ? image : srcFileZoneSideBar}
                className="w-full xxs:w-[150px] h-auto justify-start rounded-xl"
              />
              <input
                type="file"
                id="file"
                className="hidden"
                onChange={onFileResize}
                accept="image/png, image/gif, image/jpeg"
              />
            </label>
          </div>
          <div className="border-0 w-full col-span-7 grid grid-rows-1 text-center sm:py-7 flex-1">
            <div className="border-0 row-span-1 font-bold text-Secondary text-[5vw] smm:text-[20px]">
              {state?.group?.name}
            </div>
            <div className="border-0 row-span-1 font-regular text-[4vw] smm:text-[20px]">
              {state?.group?.description}
            </div>
            <div className="border-0 row-span-1 font-regular text-[4vw] smm:text-[20px] px-3">
              <Fbutton
                value="Compartir"
                onClick={() => {
                  route("/DisperseScreen", {
                    state: {
                      members: members,
                      groupId: state.group.id,
                    },
                  });
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <FContainer>
        <div className="border-0 w-full grid grid-cols-2 py-5 px-3">
          <div className="border-0 col-span-1 font-bold float-left text-[18px]">
            Integrantes
          </div>
          <div className="border-0 grid place-items-end">
            <PersonAddOutline
              width="29px"
              height="29px"
              cssClasses="ml-5 float-left  cursor-pointer"
              onClick={() => {
                route("/AddPerson", {
                  state: {
                    members: idMembers,
                    groupId: state.group.id,
                    type: "add",
                  },
                });
              }}
            />
          </div>
        </div>


            {members.map((member) => (
              <FcardContact
              backgroundInitial={aleatory3colorss}
                preferredName={member.preferredName}
                phoneNumber={member.phoneNumber}
                onDeleteMembers={()=>{
                  onDeleteClickBanks(member)
                }}
              />
            ))}



      </FContainer>
    </>
  );
};

export default ManageGroupScreen;
